var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "90px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "交易单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.orderNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "orderNo", $$v)
                                },
                                expression: "listPram.orderNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商家订单号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.merNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "merNo", $$v)
                                },
                                expression: "listPram.merNo",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "交易状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.payStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "payStatus", $$v)
                                },
                                expression: "listPram.payStatus",
                              },
                            },
                            _vm._l(_vm.offsetStateOption, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.userType === 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "下单小程序" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handerSearch },
                                  model: {
                                    value: _vm.listPram.appId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "appId", $$v)
                                    },
                                    expression: "listPram.appId",
                                  },
                                },
                                _vm._l(_vm.orderListWx, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.appName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.storeType && _vm.userType !== 2
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "核销商家" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    filterable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handleSelectedList },
                                  model: {
                                    value: _vm.listPram.offlineSupplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.listPram,
                                        "offlineSupplierId",
                                        $$v
                                      )
                                    },
                                    expression: "listPram.offlineSupplierId",
                                  },
                                },
                                _vm._l(_vm.formStoreSelect, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销门店" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.offlineStoreId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "offlineStoreId", $$v)
                                },
                                expression: "listPram.offlineStoreId",
                              },
                            },
                            _vm._l(_vm.formStoreSelectedOne, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { label: item.value, value: item.key },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户手机号" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth ",
                              attrs: {
                                placeholder: "请输入",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "phone", $$v)
                                },
                                expression: "listPram.phone",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "核销方式" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "selWidth ",
                              attrs: { clearable: "", placeholder: "请选择" },
                              on: { change: _vm.handerSearch },
                              model: {
                                value: _vm.listPram.verification,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "verification", $$v)
                                },
                                expression: "listPram.verification",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "小程序", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "扫码枪", value: 2 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.userType !== 2
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "付款类型" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "selWidth ",
                                  attrs: {
                                    clearable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.handerSearch },
                                  model: {
                                    value: _vm.listPram.codeType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listPram, "codeType", $$v)
                                    },
                                    expression: "listPram.codeType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "动态码", value: 1 },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "实体码", value: 2 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "交易时间" } },
                        [
                          _c("el-date-picker", {
                            staticClass: "selWidth ",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "range-separator": "-",
                              "start-placeholder": "开始日期",
                              "end-placeholder": "结束日期",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.dataRenage,
                              callback: function ($$v) {
                                _vm.dataRenage = $$v
                              },
                              expression: "dataRenage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "mr20",
              attrs: { type: "primary" },
              on: { click: _vm.handerSearch },
            },
            [_vm._v("搜索")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["admin:order:offsetRefund:view:export"],
                  expression: "['admin:order:offsetRefund:view:export']",
                },
              ],
              staticClass: "mr20",
              attrs: { type: "primary", disabled: _vm.isExporting },
              on: { click: _vm.exportList },
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(_vm.isExporting ? "导出中..." : "结果导出") +
                  "\n\t\t"
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "mr20",
              attrs: { type: "success" },
              on: { click: _vm.openDownloadTaskDialog },
            },
            [
              _c("i", { staticClass: "el-icon-document" }),
              _vm._v(" 导出任务\n\t\t"),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.isExporting,
                title: "导出中",
                "show-close": false,
                "close-on-click-modal": false,
                "custom-class": "export-dialog",
                width: "450px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isExporting = $event
                },
              },
            },
            [
              _c("div", { staticClass: "export-dialog-content" }, [
                _vm.isInQueue
                  ? _c("div", { staticClass: "queue-mode" }, [
                      _c("div", { staticClass: "queue-icon-wrapper" }, [
                        _c("i", { staticClass: "el-icon-refresh queue-icon" }),
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "export-title queue-title" }, [
                        _vm._v("您已进入排队队列"),
                      ]),
                      _vm._v(" "),
                      _vm.currentQueuePosition > 0
                        ? _c("div", { staticClass: "queue-position" }, [
                            _vm._v("\n\t\t\t\t\t\t当前排队位置：第 "),
                            _c("span", { staticClass: "queue-number" }, [
                              _vm._v(_vm._s(_vm.currentQueuePosition)),
                            ]),
                            _vm._v(" 位\n\t\t\t\t\t"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.queueDetail
                        ? _c("div", { staticClass: "queue-detail-info" }, [
                            _vm.queueDetail.processingTask
                              ? _c("div", { staticClass: "detail-row" }, [
                                  _c("span", { staticClass: "detail-label" }, [
                                    _vm._v("正在导出："),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "detail-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.queueDetail.processingTask
                                          .taskTypeName
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.queueDetail.processingTask.progress
                                    ? _c(
                                        "span",
                                        { staticClass: "detail-progress" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t(" +
                                              _vm._s(
                                                _vm.queueDetail.processingTask
                                                  .progress
                                              ) +
                                              "%)\n\t\t\t\t\t\t\t"
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.queueDetail.waitingCount > 0
                              ? _c("div", { staticClass: "detail-row" }, [
                                  _c("span", { staticClass: "detail-label" }, [
                                    _vm._v("排队中："),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "detail-value" }, [
                                    _vm._v(
                                      _vm._s(_vm.queueDetail.waitingCount) +
                                        " 个任务"
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "queue-waiting-hint" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _vm._v(
                          "\n\t\t\t\t\t\t前方有导出任务正在执行，请耐心等待\n\t\t\t\t\t"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "queue-tip" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t排队期间请勿关闭页面，任务将在前方完成后自动开始\n\t\t\t\t\t"
                        ),
                      ]),
                    ])
                  : _c("div", [
                      _c("i", { staticClass: "el-icon-download export-icon" }),
                      _vm._v(" "),
                      _c("h3", { staticClass: "export-title" }, [
                        _vm._v("正在导出数据，请稍候..."),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "progress-container" },
                        [
                          _vm.exportProgress < 100
                            ? _c("el-progress", {
                                attrs: {
                                  percentage: _vm.exportProgress,
                                  "stroke-width": 20,
                                  color: _vm.customColors,
                                  "text-inside": true,
                                },
                              })
                            : _c("el-progress", {
                                attrs: {
                                  percentage: 100,
                                  "stroke-width": 20,
                                  color: "#67C23A",
                                  status: "success",
                                  "text-inside": true,
                                },
                              }),
                          _vm._v(" "),
                          _c("div", { staticClass: "progress-info" }, [
                            _c("span", { staticClass: "status-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.exportProgress < 100
                                    ? "导出处理中..."
                                    : "导出完成！"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "progress-text" }, [
                              _vm._v(_vm._s(_vm.exportProgress) + "%"),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "交易单号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merNo",
                  label: "商家订单号",
                  "min-width": "190",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productQuantity",
                  label: "商品数量",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _vm.userType !== 2
                ? _c("el-table-column", {
                    attrs: {
                      prop: "appName",
                      label: "小程序",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "核销方式", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              scope.row.verification === 1
                                ? "小程序"
                                : scope.row.verification === 2
                                ? "扫码枪"
                                : "未知"
                            ) +
                            "\n\t\t\t\t"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.userType !== 2
                ? _c("el-table-column", {
                    attrs: { label: "付款方式", "min-width": "190" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    scope.row.codeType === 1
                                      ? "动态码"
                                      : scope.row.codeType === 2
                                      ? "实体码"
                                      : "未知"
                                  ) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3000421533
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "", label: "订单金额", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s("￥" + scope.row.payAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "平台收款", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.userType !== 2
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "flex-direction": "column",
                                  "align-items": "flex-start",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { color: "#f56c6c" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        "￥" +
                                          (
                                            scope.row.paidPrice +
                                            scope.row.useIntegral
                                          ).toFixed(2)
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s("福豆：￥" + scope.row.useIntegral)
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s("微信：￥" + scope.row.paidPrice)
                                  ),
                                ]),
                              ]
                            )
                          : _c("span", { staticStyle: { color: "#f56c6c" } }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    "￥" +
                                      (
                                        scope.row.paidPrice +
                                        scope.row.useIntegral
                                      ).toFixed(2)
                                  ) +
                                  "\n\t\t\t\t\t"
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierPaid",
                  label: "商家收款",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierPrice",
                  label: "成本价",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.supplierPrice != null
                                ? "￥" +
                                    Number(scope.row.supplierPrice).toFixed(2)
                                : "-"
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payStatusName",
                  label: "交易状态",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(
                                scope.row.orderStatus
                              ),
                            },
                          },
                          [_vm._v(_vm._s(scope.row.payStatusName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "startTimeStr",
                  label: "交易发起时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "endTimeStr",
                  label: "交易结束时间",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userInfo",
                  label: "下单用户",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "offlineStoreName",
                  label: "核销门店",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _vm.userType == 2
                ? _c("el-table-column", {
                    attrs: {
                      prop: "serialNo",
                      label: "流水号",
                      "min-width": "120",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "offlineUserName",
                  label: "操作人",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "80",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openOrderDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "详情",
            visible: _vm.dialogVisibleDetals,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleDetals = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                padding: "15px",
                "margin-bottom": "15px",
                "border-bottom": "1px solid #e4e7ed",
              },
            },
            [
              _c(
                "h3",
                {
                  staticStyle: {
                    margin: "0 0 10px 0",
                    color: "#303133",
                    "font-size": "16px",
                  },
                },
                [_vm._v("基础信息")]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("交易订单号：" + _vm._s(_vm.popupDetales.orderNo)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("商家订单号：" + _vm._s(_vm.popupDetales.merNo)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "交易发起时间：" + _vm._s(_vm.popupDetales.startTimeStr)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("下单用户：" + _vm._s(_vm.popupDetales.userInfo)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticStyle: { "margin-bottom": "8px" } },
                      [
                        _vm._v("订单状态："),
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getOrderStatusType(
                                _vm.popupDetales.orderStatus
                              ),
                              size: "small",
                            },
                          },
                          [_vm._v(_vm._s(_vm.popupDetales.payStatusName))]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "用户流水号：" + _vm._s(_vm.popupDetales.serialNo)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "交易完成时间：" + _vm._s(_vm.popupDetales.endTimeStr)
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("成交小程序：" + _vm._s(_vm.popupDetales.appName)),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                padding: "15px",
                "margin-bottom": "15px",
                "border-bottom": "1px solid #e4e7ed",
              },
            },
            [
              _c(
                "h3",
                {
                  staticStyle: {
                    margin: "0 0 10px 0",
                    color: "#303133",
                    "font-size": "16px",
                  },
                },
                [_vm._v("交易信息")]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("订单金额："),
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v("￥ " + _vm._s(_vm.popupDetales.payAmount)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("平台收款："),
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v(
                          "￥ " +
                            _vm._s(
                              (
                                _vm.popupDetales.paidPrice +
                                _vm.popupDetales.useIntegral
                              ).toFixed(2)
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.userType != 2
                        ? _c("span", [
                            _vm._v(
                              "（福豆：￥ " +
                                _vm._s(_vm.popupDetales.useIntegral || 0) +
                                "，微信：￥ " +
                                _vm._s(_vm.popupDetales.paidPrice || 0) +
                                "）"
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _vm.userType != 2
                      ? _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                          _vm._v(
                            "付款类型：" +
                              _vm._s(
                                _vm.popupDetales.codeType === 1
                                  ? "动态码"
                                  : _vm.popupDetales.codeType === 2
                                  ? "实体码"
                                  : "未知"
                              )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("商家收款："),
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v(
                          "￥ " + _vm._s(_vm.popupDetales.supplierPaid || 0)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v("成本价："),
                      _c("span", { staticStyle: { color: "#f56c6c" } }, [
                        _vm._v(
                          "￥ " +
                            _vm._s(
                              _vm.popupDetales.supplierPrice != null
                                ? Number(
                                    _vm.popupDetales.supplierPrice
                                  ).toFixed(2)
                                : "0.00"
                            )
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                padding: "15px",
                "margin-bottom": "15px",
                "border-bottom": "1px solid #e4e7ed",
              },
            },
            [
              _c(
                "h3",
                {
                  staticStyle: {
                    margin: "0 0 10px 0",
                    color: "#303133",
                    "font-size": "16px",
                  },
                },
                [_vm._v("核销信息")]
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "核销供应商：" +
                          _vm._s(_vm.popupDetales.offlineSupplierName || "")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "核销方式：" +
                          _vm._s(
                            _vm.popupDetales.verification === 1
                              ? "小程序"
                              : _vm.popupDetales.verification === 2
                              ? "扫码枪"
                              : "未知"
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "核销门店：" +
                          _vm._s(_vm.popupDetales.offlineStoreName || "")
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                      _vm._v(
                        "操作人：" + _vm._s(_vm.popupDetales.offlineUserName)
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.popupDetales.verification == 2
            ? _c(
                "div",
                {
                  staticStyle: {
                    padding: "15px",
                    "margin-bottom": "15px",
                    "border-bottom": "1px solid #e4e7ed",
                  },
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        color: "#303133",
                        "font-size": "16px",
                      },
                    },
                    [_vm._v("商品明细")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.displayProductList,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { prop: "productId", label: "商家商品ID" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "productName", label: "商品名" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productBarCode",
                          label: "条形码",
                          width: "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productQuantity",
                          label: "数量",
                          width: "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productPrice",
                          label: "单价",
                          width: "80",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "", label: "小计", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        scope.row.productPrice *
                                          scope.row.productQuantity
                                      ) +
                                      "\n\t\t\t\t\t"
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          181920585
                        ),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "图片", width: "100" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("el-image", {
                                    staticStyle: {
                                      width: "30px",
                                      height: "30px",
                                    },
                                    attrs: {
                                      src: scope.row.productImage,
                                      fit: "cover",
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1488883086
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.needProductExpand
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "margin-top": "10px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  _vm.productListExpanded =
                                    !_vm.productListExpanded
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.productListExpanded
                                      ? "收起"
                                      : "展开全部(" +
                                          _vm.popupDetales.productList.length +
                                          "条)"
                                  ) +
                                  "\n\t\t\t\t\t"
                              ),
                              _c("i", {
                                class: _vm.productListExpanded
                                  ? "el-icon-arrow-up"
                                  : "el-icon-arrow-down",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.popupDetales.orderStatus == 8 ||
          _vm.popupDetales.orderStatus == 14 ||
          _vm.popupDetales.orderStatus == 7
            ? _c(
                "div",
                {
                  staticStyle: {
                    padding: "15px",
                    "margin-bottom": "15px",
                    "border-bottom": "1px solid #e4e7ed",
                  },
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        color: "#303133",
                        "font-size": "16px",
                      },
                    },
                    [_vm._v("退款信息")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                          _vm._v(
                            "退款类型：" +
                              _vm._s(_vm.popupDetales.payStatusName)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                          _vm._v("平台退款金额："),
                          _c("span", { staticStyle: { color: "#f56c6c" } }, [
                            _vm._v(
                              "￥ " + _vm._s(_vm.popupDetales.refundAmount || 0)
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.userType != 2
                            ? _c("span", [
                                _vm._v(
                                  "（福豆：￥ " +
                                    _vm._s(
                                      _vm.popupDetales.refundIntegral || 0
                                    ) +
                                    "，微信：￥ " +
                                    _vm._s(
                                      _vm.popupDetales.refundPaidPrice || 0
                                    ) +
                                    "）"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                          _vm._v("退款金额："),
                          _c("span", { staticStyle: { color: "#f56c6c" } }, [
                            _vm._v(
                              "￥ " +
                                _vm._s(
                                  Number(_vm.popupDetales.refundAmount) +
                                    Number(
                                      _vm.popupDetales.extraRefundAmount
                                    ) || 0
                                )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
                          _vm._v("商家退款金额："),
                          _c("span", { staticStyle: { color: "#f56c6c" } }, [
                            _vm._v(
                              "￥ " +
                                _vm._s(_vm.popupDetales.extraRefundAmount || 0)
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.popupDetales.orderStatus == 14
                    ? _c(
                        "h4",
                        {
                          staticStyle: {
                            margin: "15px 0 10px 0",
                            color: "#303133",
                            "font-size": "14px",
                          },
                        },
                        [_vm._v("退款商品明细")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.popupDetales.orderStatus == 14
                    ? _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.displayRefundProductList,
                            border: "",
                            size: "mini",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { prop: "productId", label: "商家商品ID" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "productName", label: "商品名" },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "productBarCode",
                              label: "条形码",
                              width: "120",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "refundProductQuantity",
                              label: "数量",
                              width: "80",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "productPrice",
                              label: "单价",
                              width: "80",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { prop: "", label: "小计", width: "80" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t" +
                                          _vm._s(
                                            scope.row.productPrice *
                                              scope.row.refundProductQuantity
                                          ) +
                                          "\n\t\t\t\t\t"
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2817299111
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "图片", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "30px",
                                          height: "30px",
                                        },
                                        attrs: {
                                          src: scope.row.productImage,
                                          fit: "cover",
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1488883086
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.needRefundProductExpand &&
                  _vm.popupDetales.orderStatus == 14
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "margin-top": "10px",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  _vm.refundProductListExpanded =
                                    !_vm.refundProductListExpanded
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.refundProductListExpanded
                                      ? "收起"
                                      : "展开全部(" +
                                          _vm.popupDetales.refundProductList
                                            .length +
                                          "条)"
                                  ) +
                                  "\n\t\t\t\t\t"
                              ),
                              _c("i", {
                                class: _vm.refundProductListExpanded
                                  ? "el-icon-arrow-up"
                                  : "el-icon-arrow-down",
                              }),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userType != 2
            ? _c(
                "div",
                {
                  staticStyle: {
                    padding: "15px",
                    "border-bottom": "1px solid #e4e7ed",
                  },
                },
                [
                  _c(
                    "h3",
                    {
                      staticStyle: {
                        margin: "0 0 10px 0",
                        color: "#303133",
                        "font-size": "16px",
                      },
                    },
                    [_vm._v("操作日志列表")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.popupDetales.orderLogtList,
                        border: "",
                        size: "mini",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "时间",
                          width: "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operate",
                          label: "操作人",
                          width: "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "content", label: "日志明细" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "reqParam", label: "请求参数" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "download-task-dialog",
          attrs: {
            visible: _vm.downloadTaskDialogVisible,
            title: "导出任务列表",
            width: "90%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.downloadTaskDialogVisible = $event
            },
          },
        },
        [_vm.downloadTaskDialogVisible ? _c("download-task") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }